import type { FaireProductEntity } from "../../entity_types/product";

export const p_f77wgcu42b: FaireProductEntity = {
  token: "p_f77wgcu42b",
  type: "product",
  name: "acorn sticker",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/026eda4ed3deb7debd864cf6c1a2b15f5fdb4d2e772073ec0a89e4ee34c2df19.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description:
    'Add this sticker to your water bottle, laptop, journal, envelopes, and more.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n• vinyl sticker\n• 3" x 3"\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:54.111Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
